export { SpiderWebContainer } from "./spiderweb-container";
export {
    clientPointToSpiderWebPercent,
    getFillColor,
    getRectangleBorderRadius,
    VIEWBOX_SCALE
} from "./spiderweb-utils";
export {
    computeDocumentSectionScrollProgress,
    getNearestVerticalScrollContainer,
    useSpiderwebDocumentSectionProgress
} from "./use-spiderweb-document-section-progress";
export {
    animationPhasesUseScrollWindows,
    scrollWindowPhase
} from "./scroll-window-phases";
export type { ScrollWindowPhaseTarget } from "./scroll-window-phases";
export {
    ANIMATION_PHASES_SCROLL_TIMELINE_UNITS_DEFAULT,
    usableColors
} from "./spiderweb-types";
export type {
    AnimationPhase,
    AnimationPhasesDrive,
    SpiderWebCanvasClickPct,
    SpiderWebContainerProps,
    SpiderWebNodeFocus,
    SpiderWebNodeFocusVariant,
    WebNodeConfig,
    WebConnectorConfig,
    ConnectorBias,
    NodeShape,
    ConnectorShape,
    ConnectorType,
    AnimationColor,
    FillColor,
    SpiderWebNodeBorderColor,
    ModalContent,
    OverlapFill,
    WebNodeOverlapConfig
} from "./spiderweb-types";
export { AnimatedModal } from "@/components/adg4/animated-modal/src";
export type {
    AnimatedModalContent,
    AnimatedModalProps
} from "@/components/adg4/animated-modal/src";
